import React, {useEffect, useReducer, useState} from 'react';
import {Button, Form, Input, Radio, Upload, Icon, Dialog, Notification, Loading} from '@alifd/next';
import styles from "./index.module.scss";
import LzMsg from '@/components/common/LzMsg';
import { Servlets } from '@/service/index';
import utils from "@/common/utils";
import {history} from "ice";
import * as XLSX from 'xlsx';
import moment from "moment";

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const formItemLayout = {
  labelCol: {
    fixedSpan: 8,
  },
  wrapperCol: {
    span: 14,
  },
};

const initFormData = {
  name : '',
  desc: '',
  fileType: 1,
  crowdType: 1,
  crowdExpire: 1,
  excelFile: '',
};

const fileTypes = [
  {
    value: 1,
    label: '上传手机号',
  },
  {
    value: 2,
    label: '上传抖店openid',
  },
  {
    value: 3,
    label: '上传订单号',
  },
]

const expireTimes  = [
  {
    value: 1,
    label: <span>
      <span style={{ color: '#333333' }}>15天</span>
      <span style={{ color: '#ccc' }}>（每日上限 0/50 次）</span>
    </span>,
  },
  {
    value: 2,
    label: <span>
      <span style={{ color: '#333333' }}>365天</span>
      <span style={{ color: '#ccc' }}>（每日上限 0/5 次）</span>
    </span>,
  }
]

const PhoneUpload = () => {
  const [formData, setFormData] = useReducer((p, c) => {
    return {...p, ...c}
  }, initFormData);
  const [visible, setVisible] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [currentFileType, setCurrentFileType] = useState('1');

  const downloadTemplate = () => {
    let url = '';
    switch (formData.fileType) {
      case 1:
        // 上传手机号模板
        url = 'https://s3.cn-north-1.jdcloud-oss.com/lz-crowd/dy/template/%E6%89%8B%E6%9C%BA%E5%8F%B7%E5%BD%95%E5%85%A5%E6%A8%A1%E7%89%88.xlsx';
        break;
      case 2:
        // 上传抖店openid模板
        url = 'https://s3.cn-north-1.jdcloud-oss.com/lz-crowd/dy/template/%E6%8A%96%E5%BA%97openId%E5%BD%95%E5%85%A5%E6%A8%A1%E7%89%88.xlsx';
        break;
      case 3:
        // 上传订单号模板
        url = 'https://s3.cn-north-1.jdcloud-oss.com/lz-crowd/dy/template/%E8%AE%A2%E5%8D%95%E5%8F%B7%E5%BD%95%E5%85%A5%E6%A8%A1%E7%89%88.xlsx';
        break;
      default:
        break;
    }
    if (url) {
      const a = document.createElement('a');
      a.href = url;
      a.download = '模板.xlsx'; // 设置下载文件名
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const createCrowds = (v) => {
    if(!formData.name){
      LzMsg.error('请输入人群包名称')
      return;
    }
    if(!formData.excelFile){
      LzMsg.error('请上传文件')
      return;
    }
    setCreateLoading(true);
    Servlets('saveCrowd', {
      peopleName: formData.name,
      peopleDescription: formData.desc,
      fileType: formData.fileType == 1 ? 9 : formData.fileType == 2 ? 10 : formData.fileType == 3 && formData.crowdType == 1 ? 8 : 7,
      crowdExpireType: formData.crowdExpire,
      s3Url: formData.excelFile,
    }).then((res:any) => {
      if(res.success){
        setCreateLoading(false);
        tips('success', '保存人群成功', '成功');
        // setTipVisible(true);
        history.push('/CustomerManagement');
      } else {
        setCreateLoading(false);
        tips('error', res.resp_msg, '失败');
      }
    }).catch((e) => {
      console.log('e',e);
      setCreateLoading(false);
      tips('error', '请求失败，请稍后重试', '失败');
    });
  };

  const setBreadcrumb = () => {
    utils.setBreadcrumb({
      name: "客户管理",
      url: "/web/CustomerManagement",
      children: {
        name: "人群管理",
        url: "/web/CustomerManagement",
        children: {
          name: "人群上传",
          url: "",
        },
      },
    });
  };

  const [iconType, setIconType] = useState(1);
  const [fileName, setFileName] = useState('');

  // 提示弹窗
  const tips = (type, content, title) => {
    Notification.open({
      title,
      content,
      type,
    });
  };

  const changeFileType = () => {
    setFormData({
      fileType: currentFileType,
      crowdType: 1,
      crowdExpire: 1,
      excelFile: '',
    })
    setIconType(1);
    setFileName('');
    setVisible(false);
  };
  const onClose = () => {
    setVisible(false);
  };


  const [tipVisible, setTipVisible] = useState(false);
  const tipClose = () => {
    setTipVisible(false);
  }

  const [longDayTimes, setLongDayTimes] = useState(0);
  const [shortDayTimes, setShortDayTimes] = useState(0);

  const getCrowdTimes = () => {
    Servlets('getCrowdTime', {}).then((res:any) => {
      if(res.success){
        console.log('res', res);
        setLongDayTimes(res.data.longDayTimes);
        setShortDayTimes(res.data.shortDayTimes);
      } else {
        tips('error', res.resp_msg, '失败');
      }
    }).catch((e) => {
      console.log('e',e);
      tips('error', '请求失败，请稍后重试', '失败');
    });
  }

  useEffect(() => {
    const currentTime = moment().format('MM月DD日 HH点mm分ss秒')
    setFormData({
      name: `默认创建${currentTime}`,
      desc: `默认创建${currentTime}`
    });
    setBreadcrumb();
    getCrowdTimes();
  }, []);

  return  <div className={styles['PhoneUpload']}>
    <Loading visible={createLoading} fullScreen>
      <Form style={{ width: '60%' }} {...formItemLayout} colon>
        <FormItem label="人群名称" required requiredMessage="请输入人群名称">
          <Input value={formData.name} maxLength={37} showLimitHint onChange={(name) => {
            setFormData({name})
          }}/>
        </FormItem>
        <FormItem label="人群描述">
          <Input value={formData.desc} maxLength={37} showLimitHint onChange={(desc) => {
            setFormData({desc})
          }}/>
        </FormItem>
        <FormItem label="上传文件类型" required requiredMessage={'请选择上传文件类型'}>
          <RadioGroup value={formData.fileType} aria-labelledby="groupId" onChange={(fileType) => {
            if(formData.excelFile){
              setCurrentFileType(fileType);
              setVisible(true);
            } else {
              setFormData({
                fileType,
                crowdType: 1,
                crowdExpire: 1,
                excelFile: '',
              })
            }
          }}>
            {
              fileTypes.map(v => {
                return <Radio key={v.value} id={v.value} value={v.value}>
                  {v.label}
                </Radio>
              })
            }
          </RadioGroup>
          <Button style={{ marginLeft: '20px' }} type="primary" text onClick={downloadTemplate}>下载模版</Button>
        </FormItem>
        <FormItem label="生成人群类型" required requiredMessage={'请选择生成人群类型'}>
          <RadioGroup value={formData.crowdType} aria-labelledby="groupId" onChange={(crowdType) => {
            setFormData({crowdType})
          }}>
            <Radio key={1} id={1} value={1}>生成官方人群</Radio>
            {
              formData.fileType == 3 && <Radio key={2} id={2} value={2}>生成云鹿人群</Radio>
            }
          </RadioGroup>
        </FormItem>
        <FormItem label="人群包有效期" required={true} requiredMessage={'请选择人群包有效期'}>
          {
            !(formData.fileType == 3 && formData.crowdType == 2) && <RadioGroup value={formData.crowdExpire} aria-labelledby="groupId" onChange={(crowdExpire) => {
              setFormData({crowdExpire})
            }}>
              <Radio key={1} id={1} value={1}>
                <span style={{ color: '#333333' }}>15天</span>
                <span style={{ color: '#ccc' }}>（每日上限 {shortDayTimes}/50 次）</span>
              </Radio>
              <Radio key={2} id={2} value={2}>
                <span style={{ color: '#333333' }}>365天</span>
                <span style={{ color: '#ccc' }}>（每日上限 {longDayTimes}/5 次）</span>
              </Radio>
            </RadioGroup>
          }
          <div className={styles.tipPanel}>
            <i className={['iconfont', 'icon-icon-30', styles.icon].join(' ')} />
            <div>
              上传须知：<br/>
              1、请按模板样式上传文件，仅支持.xlsx格式，单次上传文件需小于50MB，上传过程中请勿关闭当前页面；<br/>
              2、上传文件类型选择手机号和抖店openid时，生成人群类型仅支持选择官方人群；<br/>
              3、单次上传文件最多支持100万条数据；<br/>
              4、选用手机号和抖店openid上传人群时，人群数量需超100人；<br/>
              5、因官方限制，手动上传人群包为临时人群包，且有每日每店上传上限；<br/>
              <span style={{ color: 'red' }}>6、通过手机号生成的人群包系统会排除掉无抖音账号人群；</span>
            </div>
          </div>
          {/*
          todo：上传文件接口
        */}
          <Upload.Dragger
            method="post"
            headers={{
              prod: "dy_cjyx",
              Authorization: sessionStorage.getItem('LZ_SSO_TOKEN'),
              // 'Content-Type': 'multipart/form-data',
            }}
            action="/api/yunlu/crowd/manage/crowdExcelUpload"
            withCredentials={false}
            name="uploadedFile"
            onProgress={
              // 加载中
              () => {
                console.log('progress callback');
                setIconType(4);
              }
            }
            beforeUpload={(file) => {
              return new Promise((resolve, reject) => {
                console.log('beforeUpload callback', file);
                setFileName(file.name);
                const isXlsx = file.name.endsWith('.xlsx');
                if (!isXlsx) {
                  reject(new Error('文件非.xlsx格式'));
                  return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                  try {
                    const data = new Uint8Array(e.target.result as ArrayBuffer);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                    console.log('jsonData', jsonData);

                    if (jsonData.length < 2) {
                      setIconType(3);
                      reject(new Error('文件缺少数据行'));
                      return;
                    }

                    const headerRow = jsonData[0];
                    const hasPhone = headerRow.some(cell =>
                      typeof cell === 'string' && cell.toLowerCase().includes('phone')
                    );
                    const hasOpenId = headerRow.some(cell =>
                      typeof cell === 'string' && cell.toLowerCase().includes('openid')
                    );
                    const hasOrderId = headerRow.some(cell =>
                      typeof cell === 'string' && cell.toLowerCase().includes('orderid')
                    );

                    // 上传手机号类型
                    if (formData.fileType === 1 && !hasPhone) {
                      setIconType(3);
                      reject(new Error('文件缺少phone字段'));
                      return;
                    }

                    // 上传抖店openId类型
                    if (formData.fileType === 2 && !hasOpenId) {
                      setIconType(3);
                      reject(new Error('文件缺少openId字段'));
                      return;
                    }

                    // 上传订单号类型
                    if (formData.fileType === 3 && !hasOrderId) {
                      setIconType(3);
                      reject(new Error('文件缺少orderId字段'));
                      return;
                    }

                    // 校验通过，允许上传
                    setIconType(4);
                    resolve(file); // 允许上传
                  } catch (error) {
                    setIconType(3);
                    reject(new Error('文件解析失败'));
                  }
                };

                reader.onerror = () => {
                  setIconType(3);
                  reject(new Error('文件读取失败'));
                };

                reader.readAsArrayBuffer(file);
              });
            }}
            // 移除文件
            onRemove={(file) => {
              console.log('remove callback')
              setIconType(1);
              return true;
            }}
            onError={(value:any) => {
              console.log('error callback', value);
              setIconType(3);
              if(value.error.message && value.error.message != "RESPONSE_FAIL"){
                tips('error', value.error.message, '上传失败');
              }else if(value.response.resp_msg){
                tips('error', value.response.resp_msg, '上传失败');
              }
            }}
            onSuccess={(res) => {
              console.log('success callback', res);
              setIconType(2);
              setFormData({
                excelFile: res.response.data,
              })
              tips('success', '上传成功', '成功');
            }}
          >
            <div
              className="next-upload-drag"
              style={{
                border: '1px dashed #1677ff',
                height: '150px',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '10px',
              }}
            >
              {
                iconType === 1 ? (
                  <div className={styles['upload-drag']}>
                    <Icon type="upload" style={{ fontSize: '32px', color: '#3399FF' }}/>
                    <Button type="primary" text>点击上传文件</Button>
                  </div>
                ) : (
                  iconType === 2 ? (
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className={'iconfont icon-icon4-24'} style={{ color: '#00BB66', fontSize: '32px' }} />
                        <span style={{ lineHeight: '18px', marginLeft: '11px' }}>上传成功，</span>
                        <span
                          className={'iconfont icon-icon5-17'}
                          style={{ color: '#657180', marginRight: '3px' }}
                        /> 文件：{fileName}
                      </div>
                      <div>
                        {/* <Button type="normal" style={{ width: '88px', height: '30px', marginTop: '33px' }}>删除</Button> */}
                      </div>
                    </div>
                  ) : (
                    iconType === 3 ? (
                      <span>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className={'iconfont icon-icon4-30'} style={{ color: '#FF3333', fontSize: '32px' }} />
                        <span style={{ lineHeight: '18px', marginLeft: '11px' }}>上传失败</span>
                      </div>
                      <div>
                        {/* <Button type="primary" style={{ width: '88px', height: '30px', marginTop: '33px' }}>重新上传</Button> */}
                      </div>
                    </span>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Icon
                          type="loading"
                          style={{ color: '#3399FF', fontSize: '32px', width: '32px', height: '32px' }}
                        />
                        <div style={{
                          marginTop: '5px',
                          fontSize: '12px',
                          fontWeight: 500,
                          fontFamily: 'PingFang SC',
                        }}
                        >
                          上传中...
                        </div>
                      </div>
                    )
                  )
                )
              }
            </div>
          </Upload.Dragger>
        </FormItem>
      </Form>
      <div className={styles.bottomBtns}>
        <Button type="primary" className={`${styles.mr10}`} onClick={createCrowds} loading={createLoading}>
          保存人群
        </Button>
        <Button
          type="normal"
          className={`${styles.w88}`}
          onClick={() => {
            history.push("/CustomerManagement");
          }}
        >
          返回
        </Button>
      </div>
    </Loading>
    <Dialog
      v2
      title="提示"
      visible={visible}
      footer={false}
      onOk={changeFileType}
      onClose={onClose}
    >
      <div style={{ display: 'flex', alignItems: 'center'}}>
        <i className={['iconfont', 'icon-a-outline32', styles.iconWarn].join(' ')} style={{fontSize: '33px', fontWeight: "normal"}}/>
        <div>
          <span style={{fontSize: '15px', fontWeight: 'bold'}}>重要提示！</span><br/>
          现在切换上传类型，将会清空之前上传的数据文件，确定继续操作吗？<br/>
        </div>
      </div>
      <div className={styles.bottomBtns}>
        <Button
          type="normal"
          className={`${styles.w88} ${styles.mr10}`}
          onClick={onClose}
        >
          取消
        </Button>
        <Button type="primary" className={`${styles.w88}`} onClick={changeFileType}>
          确认
        </Button>
      </div>
    </Dialog>
    <Dialog
      v2
      title="提示"
      visible={tipVisible}
      footer={false}
      onClose={tipClose}
    >
      <div>
        <i className={['iconfont', 'icon-a-outline32', styles.iconSucc].join(' ')} style={{fontSize: '33px', fontWeight: "normal"}}/>
        <div style={{fontSize: '15px', fontWeight: 'bold', marginBottom: 13}}>正在生成中......</div>
        <div>
          <span style={{color: '#666'}}>可在</span> <span style={{fontWeight: 'bold'}}>人群管理-我的人群库</span> <span style={{color: '#666'}}>中查看进度并管理</span><br/>
        </div>
      </div>
    </Dialog>
  </div>
};

export default PhoneUpload;
